import { render } from "./SubscriptionLimits.vue?vue&type=template&id=7f9a828c"
import script from "./SubscriptionLimits.vue?vue&type=script&lang=js"
export * from "./SubscriptionLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__